module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/titlebar_slide_show_notepage_preview-a6a87e.svg";